import { ReactElement, useState } from "react";
import { Menu, MenuProps } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import "./favourite-menu.styles.scss";
import addImage from "../../assets/add-square.svg";
import { useSelector } from "react-redux";
import { StarFilled } from "@ant-design/icons";
import User from "../../models/user";
import FavouriteMenu from "../../models/favourite-menu.model";
import SidebarService from "../../layout/sidebar/sidebar.service";
import toast from "react-hot-toast";
import { ReactSVG } from "react-svg";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group"
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const FavouriteItemsComponent: React.FC = (): ReactElement => {
  const sidebarService = new SidebarService();
  const navigate = useNavigate();
  const location = useLocation();
  const user: User = useSelector((state: any) => state.user);
  const collapsed = useSelector((state: any) => state.collapseSidebar);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [activeKey, setActiveKey] = useState(location.pathname);

  const handleOpenChange = (keys: any): void => {
    setOpenKeys(keys);
  };

  const handleMenuClick = (event: any): void => {
    setActiveKey(event?.key);
    navigate(event?.key);
  };

  const removeFromFavourite = async (
    event: React.MouseEvent<HTMLElement>,
    itemId: number
  ): Promise<void> => {
    event.stopPropagation();
    const response: boolean = await sidebarService.removeFromFavouriteList(
      itemId
    );
    if (response) {
      toast.success("The page removed successfully from your favourite list!");
    }
  };

  const getItems = (): MenuItem[] => {
    const items: MenuItem[] = user.favoriteList?.map(
      (favouriteItem: FavouriteMenu): MenuItem => {
        return getItem(
          <div className="flex flex-grow justify-between items-center">
            <p>{favouriteItem.name}</p>
            <StarFilled
              className="star bg-transparent text-blue-500 hover:fill-blue-500 hover:stroke-blue-500"
              onClick={(event: React.MouseEvent<HTMLElement>) =>
                removeFromFavourite(event, favouriteItem?.id)
              }
            />
          </div>,
          favouriteItem.url,
          activeKey === favouriteItem.url ? (
            <ReactSVG src={"/images/active-dashboard.svg"} />
          ) : (
            <ReactSVG src={"/images/dashboard.svg"} />
          )
        );
      }
    );

    return items;
  };

  return (
    <div className="menu-container">
      {getItems()?.length ? (
        <Menu
          openKeys={openKeys}
          selectedKeys={[location.pathname]}
          mode="inline"
          theme="dark"
          items={getItems()}
          inlineCollapsed={collapsed}
          expandIcon={(props: any) => {
            if (props.isOpen) {
              return (
                <img
                  src={"/images/minus-square.svg"}
                  alt="Kamco-customers"
                  className="w-[20px] h-[20px]"
                />
              );
            } else {
              return (
                <img
                  src={addImage}
                  alt="Kamco-customers"
                  className="w-[20px] h-[20px]"
                />
              );
            }
          }}
          onOpenChange={handleOpenChange}
          onClick={handleMenuClick}
        />
      ) : (
        <span className="text-sm text-gray-300 font-medium w-full flex items-center justify-center">
          There is no favorite items
        </span>
      )}
    </div>
  );
};

export default FavouriteItemsComponent;
